import { render, staticRenderFns } from "./budget_detail.vue?vue&type=template&id=63226c4f"
import script from "./budget_detail.vue?vue&type=script&lang=js"
export * from "./budget_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports